import "./App.css";
import { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import LandingPage from "./components/LandingPage";
import QuizPage from "./components/QuizPage";
import ThankYouPage from "./components/ThankYouPage";
import { initMetaPixel, trackEvent } from "./lib/metaPixel";

function PixelTracker() {
  const location = useLocation();
  useEffect(() => {
    initMetaPixel();
  }, []);
  useEffect(() => {
    trackEvent("PageView");
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PixelTracker />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/quiz" element={<QuizPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
